import { getApiUrl } from "../environment"
import { catchMessage } from "./errors"

export const fetchLocalFile = (path, type) => async (dispatch) => {
  return await fetch(path)
    .then(response => type === "json" ? response.json() : response.text())
    .then(content => {
      return content
    })
    .catch(function (error) {
      catchMessage({ exception: error }, "fetchLocalFile")
    })
}

export const GetCategories = () => async (dispatch) => {
  const url = `${getApiUrl()}/categories`

  return await fetch(url)
    .then(response => response.json())
    .then(json => {
      if (!json || json?.exception) {
        dispatch(catchMessage({ exception: json?.exception || "Error" }, "GetCategories"))
        return json && (json.type === "success" || json.type === "info") ? json : null
      } else {
        return json
      }
    })
    .catch(function (error) {
      dispatch(catchMessage({ exception: error }, "GetCategories"))
    })
}

export const GetPopular = () => async (dispatch) => {
  const url = `${getApiUrl()}/popular`

  return await fetch(url)
    .then(response => response.json())
    .then(json => {
      if (!json || json?.exception) {
        dispatch(catchMessage({ exception: json?.exception || "Error" }, "GetPopular"))
        return json && (json.type === "success" || json.type === "info") ? json : null
      } else {
        return json
      }
    })
    .catch(function (error) {
      dispatch(catchMessage({ exception: error }, "GetPopular"))
    })
}

export const GetThemes = (parameters) => async (dispatch) => {
  let url = `${getApiUrl()}/themes`
  if (parameters?.hasOwnProperty("theme")) {
    url += `?category=${parameters.theme}`
  }
  if (parameters?.hasOwnProperty("keyword")) {
    url += `?keyword=${parameters.keyword}`
  }

  return await fetch(url)
    .then(response => response.json())
    .then(json => {
      if (!json || json?.exception) {
        dispatch(catchMessage({ exception: json?.exception || "Error" }, "GetThemes"))
        return json && (json.type === "success" || json.type === "info") ? json : null
      } else {
        return json
      }
    })
    .catch(function (error) {
      dispatch(catchMessage({ exception: error }, "GetThemes"))
    })
}

export const GetTheme = (id) => async (dispatch) => {
  const url = `${getApiUrl()}/theme/${id}`

  return await fetch(url)
    .then(response => response.json())
    .then(json => {
      if (!json || json?.exception) {
        dispatch(catchMessage({ exception: json?.exception || "Error" }, "GetTheme"))
        return json && (json.type === "success" || json.type === "info") ? json : null
      } else {
        return json
      }
    })
    .catch(function (error) {
      dispatch(catchMessage({ exception: error }, "GetTheme"))
    })
}